export const fontSizes = {
  12: "0.75rem",
  13: "0.825rem",
  14: "0.875rem",
  16: "1rem",
  18: "1.125rem",
  20: "1.25rem",
  22: "1.375rem",
  24: "1.5rem",
  26: "1.625rem",
  28: "1.75rem",
  32: "2rem",
  36: "2.25rem",
};
